import type { IconSvgObject } from './types';

const TvSmartIcon: IconSvgObject = [
  ["path", { d: "M19 3H5C3.34315 3 2 4.34315 2 6V16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V6C22 4.34315 20.6569 3 19 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.9 15.5C16.9 14.6163 17.6163 13.9 18.5 13.9M13.7 15.5C13.7 12.849 15.849 10.7 18.5 10.7M10.5 15.5C10.5 11.0817 14.0817 7.5 18.5 7.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 19L19 21M6 19L5 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TvSmartIcon;
